import React, { Component } from "react";
import { Link, navigate } from "gatsby";
import { Form, Button, Input, message } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

const AccountChangePassword = ({ handleSubmit, props, stateProp }) => {
  const [form] = Form.useForm();

  const validateMessages = {
    required: "Field is required!",
  };

  const { loadings } = stateProp;
  if (stateProp.submited) {
    form.resetFields();
  }

  return (
    <div className="container container--500 mart--xxl">
      <div className="action_status" style={{ lineHeight: 1.7, textAlign: "center", fontSize: '18px', marginBottom: '45px' }}></div>
      <Form
        form={form}
        name="change_password"
        size="large"
        validateMessages={validateMessages}
        onFinish={handleSubmit}
        scrollToFirstError>
        <div className="form__row">
          <label className="label" htmlFor="pass_current">
            {props.langData.label_current_password}
          </label>
          <Form.Item
            name="old_password"
            rules={[{ required: true, min: 6, max: 25 }]}>
            <Input.Password
              className="input"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>
        </div>
        <div className="form__row">
          <label className="label" htmlFor="new_password">
            {props.langData.label_new_password}
          </label>
          <Form.Item
            name="new_password"
            rules={[{ required: true, min: 6, max: 25 }]}>
            <Input.Password
              className="input"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>
        </div>
        <div className="form__row">
          <label className="label" htmlFor="confirm_password">
            {props.langData.label_confirm_password}
          </label>
          <Form.Item
            name="confirm_password"
            dependencies={["new_password"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: "Please confirm your password!",
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    "The two passwords that you entered do not match!"
                  );
                },
              }),
            ]}>
            <Input.Password
              className="input"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>
        </div>

        <div className="form__row text--center">
          <Button
            type="primary"
            className="button button--cta button"
            htmlType="submit"
            loading={loadings[0]}
            size="large">
            {props.langData.btn_label}
          </Button>
        </div>
      </Form>
    </div>
  );
};
export default AccountChangePassword;
